import { render, staticRenderFns } from "./editorSkewToolPopover.vue?vue&type=template&id=0c254cc2&"
import script from "./editorSkewToolPopover.vue?vue&type=script&lang=js&"
export * from "./editorSkewToolPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports